import React from "react";
import { useNotify } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton } from "@mui/material";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";

const RemoveItemPrerequisiteDialog = ({ curriculumId, fetchCurriculaPrerequisites, itemId, prerequisiteItemId }) => {
  const notify = useNotify();

  const handleRemove = async () => {
    await dataProvider.customRequest(
      specialistRequests.deleteCurriculaPrerequisite(curriculumId, itemId, prerequisiteItemId),
      null,
      "DELETE",
    );
    notify("Успешно изтриване на предпоставка за тема", { type: "success" });
    fetchCurriculaPrerequisites();
  };
  return (
    <ConfirmModal
      titleContent={"Изтриване на предпоставка за тема"}
      onConfirm={handleRemove}
      message="Сигурни ли сте, че искате да изтриете предпоставка за тема?"
      triggerButton={
        <IconButton color="error">
          <ClearIcon />
        </IconButton>
      }
    />
  );
};

export default RemoveItemPrerequisiteDialog;
